import React from 'react'
import Result from '../../components/Result/Result'

function ResultPage() {
  return (
    <Result />
  )
}

export default ResultPage